import { Skeleton } from "@mui/material"

import useWebAdminTranslations from "@/hooks/useWebAdminTranslations"

import { FyiWidgetContent } from "./components"
import { FYI_TRANSLATION_KEYS } from "./translationKeys"

interface FyiWidgetProps {
  page: "start" | "selectPass"
}

const FyiWidget = ({ page }: FyiWidgetProps) => {
  const { t, isLoading } = useWebAdminTranslations()

  if (isLoading)
    return (
      <Skeleton
        height={150}
        role="status"
        aria-label="Loading translations"
        sx={{ mt: 15 }}
      />
    )

  const bodyTranslationKey =
    page === "start"
      ? FYI_TRANSLATION_KEYS.TEXT_SKIPASS_STEP_ONE
      : FYI_TRANSLATION_KEYS.TEXT_SKIPASS_STEP_TWO

  return (
    <FyiWidgetContent
      heading={t(FYI_TRANSLATION_KEYS.HEADING_TEXT_SKIPASS)}
      body={t(bodyTranslationKey)}
      link={{
        url: t(FYI_TRANSLATION_KEYS.INDUSTRY_RULES_URL),
        label: t(FYI_TRANSLATION_KEYS.INDUSTRY_RULES),
      }}
    />
  )
}

export default FyiWidget
